import { render, staticRenderFns } from "./CreativeCarousel.vue?vue&type=template&id=4c24da44&scoped=true&"
import script from "./CreativeCarousel.vue?vue&type=script&lang=js&"
export * from "./CreativeCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CreativeCarousel.vue?vue&type=style&index=0&id=4c24da44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24da44",
  null
  
)

export default component.exports